<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
  
function redirectMenuLv1() {
    $('.header-navigation .menu-lv-1__action').on('click', function() {
        if (window.innerWidth > 1024 && window.scrollY > 100) {
            var url = $(this).attr('href');
            window.location.href = url
        }
    });
}

redirectMenuLv1();



  // Disable right-click context menu
  // document.addEventListener('contextmenu', function(event) {
  //   event.preventDefault();
    
  // });